import { render, staticRenderFns } from "./tyoskentelyjaksot-bar-chart.vue?vue&type=template&id=7be8ccee&"
import script from "./tyoskentelyjaksot-bar-chart.vue?vue&type=script&lang=ts&"
export * from "./tyoskentelyjaksot-bar-chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports